/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-shadow */
import { MatPaginator, MatPaginatorIntl, PageEvent } from '@angular/material/paginator';
import { Component, ViewChild, OnInit, OnDestroy, AfterViewInit, ChangeDetectionStrategy } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { Router, NavigationExtras } from '@angular/router';
import { Subject, Subscription, forkJoin, takeUntil, timer } from 'rxjs';
import { MatTab, MatTabChangeEvent } from '@angular/material/tabs';
import { MatMenuTrigger } from '@angular/material/menu';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AccountInfo } from '@azure/msal-common';
import { MatSort, Sort } from '@angular/material/sort';
import { FormService } from 'src/app/shared/services/form.service';
import { TrackEventService } from 'src/app/shared/services/track-event.service';
import { AllAdminService } from 'src/app/shared/services/all-admin.service';
import { AdminHeader } from 'src/app/shared/models/admin-header.model';
import { ConfirmationDialogComponent } from 'src/app/shared/components/confirmation-dialog/confirmation-dialog.component';
import { DialogService } from 'src/app/shared/services/dialog.service';
import { messagesConfig } from 'src/app/shared/constants/message.constants';
import { MatSnackBar } from '@angular/material/snack-bar';
import { INativeSample } from 'src/app/shared/models/i-native-sample.modal';
import { IPrecastSample } from 'src/app/shared/models/i-precast-sample.modal';
import { MessageModalComponent } from 'src/app/shared/components/message-modal/message-modal.component';
import { IMessage } from 'src/app/shared/models/message.modal';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { SubmitAuthService } from 'src/app/shared/services/submit-auth.service';
import { DateTimeUtils } from 'src/app/shared/util/date-time.utils';
import { AuthService } from 'src/app/shared/services/auth.service';
import { LandingDialogComponent } from '../../shared/components/landing-dialog/landing-dialog.component';
import { DashboardTable, typesData } from '../../shared/constants/table-column.constants';
import { NotesComponent } from '../../shared/components/notes/notes.component';
import { WorksheetService } from '../worksheet/services/worksheet.service';
import { PrecastService } from '../../shared/services/precast.service';
import { LookupService } from '../../shared/services/lookup.service';
import { IDropdown } from '../../shared/models/i-dropdown-type.modal';
import { IOfficeLocation } from '../../shared/models/i-office-location.modal';
import { UserService } from '../../shared/services/user.service';
import { IDashboardItems } from './models/idashboard-items.modal';
import { ProjectsCount } from '../../shared/models/iprojects-count.modal';
import { ShipmentReceivedComponent } from './components/shipment-received/shipment-received.component';
import { SharedService } from '../service/shared.service';
import { SelectionModel } from '@angular/cdk/collections';
import { DeleteProjectRequest } from 'src/app/shared/models/i-delete-project-request.modal';
import { DeactivateProjectRequest } from 'src/app/shared/models/i-project-deactivate-request.modal';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DashboardComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('adminTab') adminTab: MatTab | undefined;
  @ViewChild('menuTriggerprojStatus') projStatustrigger: MatMenuTrigger;
  @ViewChild(MatPaginator) public dashboarPaginator!: MatPaginator;
  @ViewChild('menuTrigger') trigger: MatMenuTrigger;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('attachmentsComponent') attachmentsComponent: any;
  private readonly destroyed$ = new Subject<boolean>();
  public dataSource = new MatTableDataSource<IDashboardItems>();
  public projectRecords: IDashboardItems[] = [];
  public projectStatuses: IDropdown[] = [];
  public materialTypes: IDropdown[] = [];
  public userAccount: AccountInfo | null; // TODO Need to remove this null occurence
  public projectsCount: ProjectsCount = new ProjectsCount();
  public displayedColumns: string[] = DashboardTable;
  public selectedMaterialTypes: string[] = [];
  public selectedProjectStatus: string[] = [];
  public materialType = '';
  public projectStatus = '';
  public searchKeyWord: any = '';
  public columnName = '';
  public recordsPerPage = 100;
  public totalRecords = 0;
  public currentPage = 1;
  public totalPages = 1;
  public showSearchResultCount = false;
  public myProjectsFlagApi = false;
  public isActiveProjectFlagApi = false;
  public isMixId = false;
  public myProjects = false;
  public dialogRef: any; // TODO Need to remove this occurance of any
  private readonly destroying$ = new Subject<void>();
  private reportDownloadSubscription = Subscription.EMPTY;
  private projectsSubscription = Subscription.EMPTY;
  private userSubscription = Subscription.EMPTY;
  public selectedTab = 0;
  public countDown = Subscription.EMPTY;
  public counter: number;
  dashboardRefresh: number;
  public tick = 1000;
  headerKeyToRowKeyMapping: { [key: string]: string } = {
  };
  public attachmentProjectId = '';

  row: any;
  userRoles: string[] = [];
  headerData: AdminHeader[] = [];
  displayedColumn: string[] = [];
  deleteRecordDialogRef: any;
  filteredNativeSamples: INativeSample[] = [];
  filteredPrecastSamples: IPrecastSample[] = [];
  errorMsg: MatDialogRef<MessageModalComponent>;
  inActiveRecordsCheckboxValue = false;
  isCheckboxDisabled = true;
  isMixIdCheckboxDisabled = true;
  mixIdCheckboxValue = false;
  allowedStatuses: string[] = [
    'Lab Manager Review', 'Ready To Report', 'Report Writer Review', 'Management Review - 1st',
    'Management Review - 2nd', 'Management Approved',
  ];

  allowAdminStatus: string[] = [
    'Ready To Report', 'Report Writer Review', 'Management Review - 1st',
    'Management Review - 2nd', 'Management Approved', 'Accounting', 'Awaiting Payment', 'Sent to Customer',
  ];

  manageReportAllowList: string[] = ['Ready To Report', 'Report Writer Review', 'Management Review - 1st',
    'Management Review - 2nd', 'Management Approved',
  ];

  addRateAllowList: string[] = [
    'Management Approved',
  ];

  billingAllowList: string[] = [
    'Management Approved', 'Accounting', 'Awaiting Payment', 'Sent to Customer',
  ];

  accountRoleAllowList: string[] = [
    'Report Writer Review', 'Management Review - 1st',
    'Management Review - 2nd', 'Management Approved', 'Accounting', 'Awaiting Payment', 'Sent to Customer',
  ];

  selection = new SelectionModel<IDashboardItems>(true, []);

  rowStatus: string;
  userSettings: any;
  defaultTurnaroundTime: number = 0;
  rushTurnaroundTime: number = 0;
  isMobile: boolean = false;
  selectedCardIndex = -1;
  selectedMobileMaterialTypes: string[] = ['precast', 'native'];
  mobilePage = 1;
  mobilePageSize = 15;
  isLoading = false;
  searchColumn: string = 'all';

  sampleCountTooltipVisible = false;
  sampleCountTooltipX = 0;
  sampleCountTooltipY = 0;
  sampleCountData: { key: string; value: string }[] = [];
  activeSoilReferenceId: string | null = null;
  // Ticked office location ids; empty = All Locations
  selectedOfficeLocations: string[] = [];
  officeLocations: IOfficeLocation[] = [];
  officeLocationsLoaded = false;
  // A projects fetch requested before the office locations loaded, run once they arrive
  private pendingProjectsFetch = false;
  private sampleCountTooltipTimeout: any;

  constructor(
    public dialogService: DialogService,
    private worksheetService: WorksheetService,
    private dashboardService: PrecastService,
    private paginator: MatPaginatorIntl,
    public userService: UserService,
    private dialog: MatDialog,
    private router: Router,
    private formService: FormService,
    private trackEventService: TrackEventService,
    private adminService: AllAdminService,
    private snackBar: MatSnackBar,
    private sharedService: SharedService,
    private submitAuthService: SubmitAuthService,
    private authService: AuthService,
    private breakpointObserver: BreakpointObserver,
    private matIconRegistry: MatIconRegistry,
    private sanitizer: DomSanitizer,
    private lookupService: LookupService
  ) {
    this.paginator.itemsPerPageLabel = 'Rows per page';
    this.matIconRegistry.addSvgIcon('cylinder', this.sanitizer.bypassSecurityTrustResourceUrl('assets/icons/precast-cylinder.svg'));
  }

  ngOnInit() {
    this.breakpointObserver.observe([Breakpoints.Handset]).subscribe(result => {
      this.isMobile = result.matches;
    });
    if (this.authService.hasRequiredRoles(['Labtech'])) {
      this.selectedTab = 1;
      this.myProjectsFlagApi = true;
      this.myProjects = true;
    }
    localStorage.removeItem('jwtToken');
    this.userAccountAndRole();

    if(this.isMobile) {
      this.getAdminCounter();
      this.fetchProjects();
      return;
    }
    this.fetchOfficeLocations();
    this.selectedOfficeLocations = this.getStoredOfficeLocations();
    if (sessionStorage.getItem('isActiveProjectFlagApi')) {
      const activeRecord = sessionStorage.getItem('isActiveProjectFlagApi');
      if (activeRecord !== null && JSON.parse(activeRecord) === true) {
        this.inActiveRecordsCheckboxValue = true;
        this.isActiveProjectFlagApi = JSON.parse(activeRecord);
        this.handleCheck();
      }
    }
    if (sessionStorage.getItem('mixIdCheckboxValue')) {
      const mixIdRecord = sessionStorage.getItem('mixIdCheckboxValue');
      if (mixIdRecord !== null && JSON.parse(mixIdRecord) === true) {
        this.mixIdCheckboxValue = true;
        this.isMixId = JSON.parse(mixIdRecord);
      }
    }
    if (sessionStorage.getItem('tabIndex')) {
      const storedNumber = sessionStorage.getItem('tabIndex');
      const tabLabel = sessionStorage.getItem('tabLabel');
      if (storedNumber !== null) {
        const myNumber = Number(storedNumber);
        this.selectedTab = myNumber;
        const initialTabChangeEvent: MatTabChangeEvent = {
          index: myNumber,
          tab: {
            textLabel: tabLabel,
          } as any,
        };
        this.onTabChanged(initialTabChangeEvent);
      }
    }
    if (sessionStorage.getItem('searchKeyWord')) {
      const search = sessionStorage.getItem('searchKeyWord');
      const seachColumn = sessionStorage.getItem('searchColumn');
      if (search !== null && search !== undefined) {
        this.searchKeyWord = decodeURIComponent(search);
        this.searchColumn = seachColumn ?? 'all';
        this.isCheckboxDisabled = false;
        this.isMixIdCheckboxDisabled = false;
      }
    }
    if (sessionStorage.getItem('materialType')) {
      const sessionStoredMaterialType = sessionStorage.getItem('materialType');
      if (sessionStoredMaterialType !== null) {
        this.selectedMaterialTypes = this.splitStringByComma(sessionStoredMaterialType);
      }
    }
    if (sessionStorage.getItem('projectStatus')) {
      const sessionStoredProjectStatus = sessionStorage.getItem('projectStatus');
      if (sessionStoredProjectStatus !== null) {
        this.selectedProjectStatus = this.splitStringByComma(sessionStoredProjectStatus);
      }
    }
    if (sessionStorage.getItem('currentPage')) {
      this.currentPage = JSON.parse(sessionStorage.getItem('currentPage') as any);
    }
    if (sessionStorage.getItem('recordsPerPage')) {
      this.recordsPerPage = JSON.parse(sessionStorage.getItem('recordsPerPage') as any);
    }
    if (sessionStorage.getItem('columnName')) {
      const colNameSort = sessionStorage.getItem('columnName');
      if (colNameSort !== null && colNameSort !== undefined) {
        this.columnName = colNameSort;
      }
    }
    localStorage.removeItem('reviewForm');
    sessionStorage.removeItem('editViewSubmission');
    sessionStorage.removeItem('uploadedFile');
    sessionStorage.removeItem('uploadedFilesList');
    sessionStorage.removeItem('geothermField');
    sessionStorage.removeItem('split-submission');
    sessionStorage.removeItem('submission-flagged');
    this.formService.attachments.next(null);
    this.dataSource.paginator = this.dashboarPaginator;
    this.getDashboardData();
    this.userSubscription = this.userService.userAccount.subscribe({
      next: (account) => {
        this.userAccount = account;
      },
    });
    this.getAdminCounter();
    this.getColumnHeader();
    this.submitAuthService.setCanSubmit(true);
  }

  ngAfterViewInit() {
    if(this.isMobile) {
      return;
    }
    this.trackEventService.onClick$.subscribe(() => {
      this.resetCounter();
    });

    this.trackEventService.onMouseMove$.subscribe(() => {
      this.resetCounter();
    });
    this.trackEventService.onMouseUp$.subscribe(() => {
      this.resetCounter();
    });

    this.trackEventService.onMKeyUp$.subscribe(() => {
      this.resetCounter();
    });

    this.trackEventService.onWindowBlur$.subscribe(() => {
      this.resetCounter();
    });
    this.countDown = timer(0, this.tick).subscribe(() => {
      this.counter -= 1;
      sessionStorage.setItem('Refresh-counter', this.counter.toString());
      if (this.counter === 0) {
        this.getDashboardData();
        this.resetCounter();
      }
    });
  }

  public fetchOfficeLocations(): void {
    this.lookupService.fetchOfficeLocations()
      .pipe(takeUntil(this.destroyed$))
      .subscribe({
        next: (officeLocations) => {
          console.log('Office locations:', officeLocations);
          this.officeLocations = Array.isArray(officeLocations) ? officeLocations : [];
          this.officeLocationsLoaded = true;
          this.updateDisplayedColumns();
          this.applyOfficeLocationSelection();
          this.runPendingProjectsFetch();
        },
        error: () => {
          this.officeLocations = [];
          this.officeLocationsLoaded = true;
          this.runPendingProjectsFetch();
        },
      });
  }

  private runPendingProjectsFetch(): void {
    if (this.pendingProjectsFetch) {
      this.fetchProjects();
    }
  }

  // Locations are scoped to the user's Entra groups: a single location is fixed, stale stored ids are dropped
  private applyOfficeLocationSelection(): void {
    let selection = this.selectedOfficeLocations.filter((id) => this.officeLocations.some((office) => office.id === id));
    if (this.officeLocations.length === 1) {
      selection = [this.officeLocations[0].id];
    }
    if (selection.join(',') !== this.selectedOfficeLocations.join(',')) {
      this.selectedOfficeLocations = selection;
      this.applyOfficeLocationFilter();
    }
  }

  get showOfficeLocationFilter(): boolean {
    return this.roleCheck(['Admin', 'Reportwriter', 'Manager', 'Labtech']);
  }

  // The column filter is only worth showing when there is more than one location to pick from
  get hasOfficeLocationChoice(): boolean {
    return this.showOfficeLocationFilter && this.officeLocations.length > 1;
  }

  get hasNoOfficeLocations(): boolean {
    return this.showOfficeLocationFilter && this.officeLocationsLoaded && this.officeLocations.length === 0;
  }

  onOfficeLocationCheckboxClick(checked: boolean, officeId: string): void {
    this.selectedOfficeLocations = checked
      ? [...this.selectedOfficeLocations, officeId]
      : this.selectedOfficeLocations.filter((id) => id !== officeId);
  }

  isAllOfficeLocationsSelected(): boolean {
    return this.officeLocations.length > 0 && this.selectedOfficeLocations.length === this.officeLocations.length;
  }

  // Value sent to the API: every location ticked is sent as no filter, so projects without a location are still included
  private get officeLocationFilterParam(): string {
    if (this.officeLocations.length > 1 && this.isAllOfficeLocationsSelected()) {
      return '';
    }
    return this.selectedOfficeLocations.join(',');
  }

  applyOfficeLocationFilter(): void {
    if (this.selectedOfficeLocations.length > 0) {
      sessionStorage.setItem('officeLocationId', this.selectedOfficeLocations.join(','));
    } else {
      sessionStorage.removeItem('officeLocationId');
    }
    // Reset to the first page so the filtered result set starts from the top
    sessionStorage.setItem('currentPage', '1');
    this.currentPage = 1;
    this.onPaginationNavigate();
  }

  // Applied means some, but not all, locations are ticked; All Locations is the same as no filter
  private isOfficeLocationFilterApplied(): boolean {
    const storedCount = this.getStoredOfficeLocations().length;
    return this.hasOfficeLocationChoice && storedCount > 0 && storedCount < this.officeLocations.length;
  }

  private getStoredOfficeLocations(): string[] {
    return (sessionStorage.getItem('officeLocationId') ?? '').split(',').filter((id) => id);
  }

  showSampleCounts(sampleCountString: string): string {
    if (!sampleCountString) {
      return '';
    }

    return sampleCountString
      .split(',')
      .map(item => {
        const [type, count] = item.split(':').map(x => x.trim());
        return { type, count };
      })
      .sort((a, b) => a.type.localeCompare(b.type))
      .map(item => {
        const shortType = item.type.charAt(0).toUpperCase();
        return `${shortType}-${item.count}`;
      })
      .join(' ');
  }

  askGeo(): void {
    localStorage.setItem('askGeoSearchKeyword', this.searchKeyWord);
    window.open('/ask-geo-result', '_blank');
  }

  precastWorksheet(projectId: string) {
    this.router.navigateByUrl(`precast-worksheet?projectId=${projectId}`);
  }

  asReceivedWorksheet(projectId: string) {
    this.router.navigateByUrl(`as-received-worksheet?projectId=${projectId}`);
  }

  moistureConditioningWorksheet(projectId: string) {
    this.router.navigateByUrl(`moisture-conditioning-worksheet?projectId=${projectId}`);
  }

  compactionWorksheet(projectId: string) {
    this.router.navigateByUrl(`compaction-worksheet?projectId=${projectId}`);
  }

  nativeSoilWorksheet(projectId: string) {
    this.router.navigateByUrl(`native-soil-worksheet?projectId=${projectId}`);
  }

  singleProctorWorksheet(projectId: string) {
    this.router.navigateByUrl(`single-proctor-worksheet?projectId=${projectId}`);
  }

  openAttachmentDrawer(projectId: string) {
    this.attachmentProjectId = projectId  ;
    this.attachmentsComponent?.openDrawer(projectId);
  }

  userAccountAndRole() {
    this.userService.userRole?.subscribe({
      next: (roles) => {
        this.userRoles = roles || [];
      }
    });

    this.userService.userAccount?.subscribe({
      next: (account) => {
        this.userAccount = account;
      }
    });
  }

  roleCheck(roles: string[]): boolean {
    return roles.some((role) => this.userRoles.includes(role));
  }

  allUserAction(): boolean {
    return this.roleCheck(['Manager', 'Admin', 'Reportwriter', 'Labtech']);
  }

  getAdminCounter() {
    this.adminService.getAdmin().subscribe(
      (responseList) => {
        this.userSettings = responseList;
        this.defaultTurnaroundTime = responseList.find((item: any) => item.key === 'defaultturnaroundtime').value;
        this.rushTurnaroundTime = responseList.find((item: any) => item.key === 'rushturnaroundtime').value;
        const adminObject = responseList.find((item: any) => item.key === 'cycletimefortvdashboard');
        if (adminObject) {
          this.counter = adminObject.value;
          this.dashboardRefresh = adminObject.value;
        }
      }
    );
  }

  resetCounter(counterTime: number = this.dashboardRefresh) {
    this.counter = counterTime || this.dashboardRefresh;
  }

  // A user with a single office location has nothing to tell apart, so the Office Location column is hidden
  private updateDisplayedColumns(): void {
    const hideOfficeLocation = this.officeLocations.length === 1;
    this.displayedColumn = ['select', ...(this.headerData ?? []).map((header) => header.key)]
      .filter((key) => !(hideOfficeLocation && key === 'officeLocation'));
  }

  getColumnHeader() {
    this.adminService.getAdminDashboard().subscribe(
      (response) => {
        this.headerData = response;
        this.headerData.sort((a, b) => a.sortOrder - b.sortOrder);
        this.updateDisplayedColumns();
        this.dataSource = new MatTableDataSource(this.projectRecords);
        this.dataSource.sort = this.sort;
        this.getColumnkeyMatch();
      }
    );
  }

  // Match header key value with row key value
  getColumnkeyMatch() {
    this.headerKeyToRowKeyMapping = {
    };
    this.headerData.forEach((header) => {
      this.headerKeyToRowKeyMapping[header.key] = header.key;
    });
  }

  // Displays the header value based on sorted order
  getDisplayName(columnName: string): string {
    const header = this.headerData.find((header) => header.key === columnName);
    return header ? header.displayName : '';
  }

  getTooltipText(columnName: string): string {
    const header = this.headerData.find((header) => header.key === columnName);
    return header ? header.tooltipText : '';
  }

  getDaysDifference(date1: string | Date, date2: string | Date): number {
    const d1 = new Date(date1);
    const d2 = new Date(date2);
    const diffInMs = Math.abs(d2.getTime() - d1.getTime());
    return Math.floor(diffInMs / (1000 * 60 * 60 * 24));
  }

  getDaysAndHoursDifference(date1: string | Date, date2: string | Date): { days: number; hours: number } {
    const d1 = new Date(date1);
    const d2 = new Date(date2);
    const diffInMs = Math.abs(d2.getTime() - d1.getTime());

    const totalHours = Math.floor(diffInMs / (1000 * 60 * 60));
    const days = Math.floor(totalHours / 24);
    const hours = totalHours % 24;

    return { days, hours };
  }

  // Displays the column row value
  getRowDataByKey(row: any, key: string, isToolTip: boolean): string {
    const rowKey = this.headerKeyToRowKeyMapping[key];
    const value = row[rowKey];
    // Show the short office code in the cell and the full office name in the tooltip
    if (key === 'officeLocation') {
      if (!value || isToolTip) {
        return value ?? '';
      }
      return this.officeLocations.find(o => o.officeName === value)?.officeCode || value;
    }

    if (key === 'submitted' || key === 'sampleReceivedDate' || key === 'dueDate' || key === 'instructionsConfirmedAt') {
      if (value === null) {
        return '';
      }
      return DateTimeUtils.getLocalDateTimeFromUTCDate(value, 'MMM dd, yyyy').toString();
    }

    if (key === 'lastStatusChangedAt') {
      if (value === null) {
        return '';
      }
      if (isToolTip) {
        return DateTimeUtils.getLocalDateTimeFromUTCDate(value, 'MMM dd, yyyy').toString();
      }
      var difference = this.getDaysAndHoursDifference(DateTimeUtils.getLocalDateTimeFromUTCDate(value), new Date());
      return `${difference.days}d : ${difference.hours.toString().padStart(2, '0')}h`;
    }

    if (key === 'rushed') {
      return value ? 'true' : 'false';
    }

    if (key === 'soilType') {
      return value.soilType;
    }

    if (key === 'referenceId') {
      return value.referenceId;
    }

    if (key === 'status') {
      return value.status;
    }
    return value;
  }

  onSearchColumnChange(value: string): void {
    sessionStorage.setItem('searchColumn', value);
    this.searchColumn = value;
    this.pageNavigate('keyWordSearch')
  }

  public getDashboardData(): void {
    this.fetchProjectsCount();
    this.fetchDashboardData();
    this.onPaginationNavigate();
  }

  public onPaginationNavigate(event?: PageEvent): void {
    if (event?.pageIndex) {
      this.currentPage = event.pageIndex + 1;
    } else {
      if (sessionStorage.getItem('currentPage')) {
        this.currentPage = JSON.parse(sessionStorage.getItem('currentPage') as any);
        if (event?.pageIndex === 0) {
          this.currentPage = 1;
        }
      } else {
        this.currentPage = 1;
      }
      this.dashboarPaginator?.firstPage();
    }
    sessionStorage.setItem('currentPage', this.currentPage.toString());

    if (event?.pageSize) {
      this.recordsPerPage = event?.pageSize ? event.pageSize : 100;
    } else if (sessionStorage.getItem('recordsPerPage')) {
      this.recordsPerPage = JSON.parse(sessionStorage.getItem('recordsPerPage') as any);
    }
    sessionStorage.setItem('recordsPerPage', this.recordsPerPage.toString());
    this.fetchProjects();
  }

  public routingPage(): void {
    this.dialog.open(LandingDialogComponent, {
      disableClose: true,
      data: 'auth',
      enterAnimationDuration: '0ms',
      exitAnimationDuration: '0ms',
    });
    sessionStorage.removeItem('uploadedFile');
  }

  //TODO: remove this method after new native soil worksheet is completed
  public gotoWorksheet(projectID: string, mode: string, soilType: string): void {
    const navigateSoilType = soilType === 'Pre Cast' ? 'precast' : 'nativesoil';
    if (mode) {
      this.router.navigateByUrl(`worksheet?soilType=${navigateSoilType}&&projectId=${projectID}`);
    } else if (soilType === 'Pre Cast') {
      this.worksheetService.generatePrecastWorksheet(projectID).subscribe({
        next: () => {
          this.fetchProjects();
          this.router.navigateByUrl(`worksheet?soilType=${navigateSoilType}&&projectId=${projectID}`);
        },
        error: () => { },
      });
    } else {
      this.worksheetService.generateNativeSoilWorksheet(projectID).subscribe({
        next: () => {
          this.fetchProjects();
          this.router.navigateByUrl(`worksheet?soilType=${navigateSoilType}&&projectId=${projectID}`);
        },
        error: () => { },
      });
    }
  }

  onCardClick(index: number) {
    if (this.selectedCardIndex === index) {
      this.selectedCardIndex = -1;
    } else {
      this.selectedCardIndex = index;
    }
  }

  // TODO: Change this any type and move the constant to constant file
  public openDialog(element: any, type: string): void {
    const messageObject = {
      projectId: element?.id,
      projectStatus: element?.status,
      projectName: element?.projectName,
      projectType: element?.soilType,
      companyName: element?.customer,
      projectNumber: element?.projectNumber,
      storageCompartment: element?.storageCompartment,
    };
    const component = type === 'Notes' ? NotesComponent : ShipmentReceivedComponent;
    this.dialogRef = this.dialog?.open<any>(component, {
      panelClass: 'app-dialog',
      data: messageObject,
      disableClose: true,
      width: type === 'Notes' ? '60%' : '70%',
    });
    if (type === 'SetStatus') {
      this.dialogRef.afterClosed().subscribe(() => {
        this.fetchProjectsCount();
        this.fetchProjects();
      });
    }
  }

  // TODO Need to think of a better name for this
  public pageNavigate(event: any): void {
    if (event === 'materialTypeCheck') {
      if (this.selectedMaterialTypes.length > 0) {
        sessionStorage.setItem('materialType', this.materialType);
      } else {
        sessionStorage.removeItem('materialType');
      }
    } else if (event === 'projectStatusCheck') {
      if (this.selectedProjectStatus.length > 0) {
        sessionStorage.setItem('projectStatus', this.projectStatus);
      } else {
        sessionStorage.removeItem('projectStatus');
      }
    }

    this.currentPage = sessionStorage.getItem('currentPage')
      ? JSON.parse(sessionStorage.getItem('currentPage') as any)
      : 1;
    this.recordsPerPage = sessionStorage.getItem('recordsPerPage')
      ? JSON.parse(sessionStorage.getItem('recordsPerPage') as any)
      : 100;
    this.onPaginationNavigate();
  }

  public onClearSearchButtonClick(): void {
    sessionStorage.removeItem('searchKeyWord');
    sessionStorage.removeItem('searchColumn');
    sessionStorage.removeItem('mixIdCheckboxValue');
    sessionStorage.removeItem('isActiveProjectFlagApi');
    this.showSearchResultCount = false;
    this.searchKeyWord = '';
    this.searchColumn = 'all';

    this.isMixId = false; // Clear include Mix Id CheckBox
    this.isActiveProjectFlagApi = false; // Clear include inactive record CheckBox
    // Make both the checkbox default
    this.inActiveRecordsCheckboxValue = false;
    this.mixIdCheckboxValue = false;
    // Disable both the check box
    this.isCheckboxDisabled = true;
    this.isMixIdCheckboxDisabled = true;
    if(this.isMobile) {
      this.fetchProjects();
    } else {
      this.getDashboardData();
    }
  }

  public onSearchChange(): void {
    this.showSearchResultCount = false;
    if (!this.searchKeyWord) {
      this.onClearSearchButtonClick();
    }
  }

  sortData(sort: Sort) {
    const selectedColumn = this.headerKeyToRowKeyMapping[sort.active];
    this.columnName = `${selectedColumn} ${sort.direction}`;
    sessionStorage.setItem('columnName', this.columnName);
    this.onPaginationNavigate();
  }

  public onCheckboxClick(
    checked: boolean,
    item: string,
    selectedItemArray: string[],
    allItems: { label: string }[],
    targetProperty: string,
  ): void {
    const itemIndex = selectedItemArray.indexOf(item);
    if (item === 'All') {
      selectedItemArray = checked ? [...allItems.map((items) => items.label)] : [];
    } else if (!checked) {
      this.removeItem(item, itemIndex, selectedItemArray, 'All', selectedItemArray);
    } else {
      this.addItem(item, selectedItemArray, 'All', allItems);
    }
    if (targetProperty === 'materialType') {
      this.selectedMaterialTypes = selectedItemArray;
    } else {
      this.selectedProjectStatus = selectedItemArray;
    }
    this.updateProperty(selectedItemArray, targetProperty, allItems);
  }

  public assignToReportWriter(projectId: string) {
    this.dashboardService
      ?.assignToReportWriter(projectId)
      ?.pipe(takeUntil(this.destroying$))
      ?.subscribe({
        next: () => {
          this.fetchProjects();
        },
      });
  }

  /**
   * Assigns the specified project to the current user.
   * This method calls the `assignToMyself` function from the `dashboardService`
   * with the provided project ID. Upon a successful assignment, it triggers
   * a fetch of the updated projects list dashboard table to reflect in the tech column changes.
   * * */
  public assignToMyself(projectId: string) {
    this.dashboardService.assignToMyself(projectId).subscribe({
      next: () => {
        this.fetchProjects();
      },
    });
  }

  public displayAdminAssignToMyself(row: any): boolean {
    const validStatuses = ['Management Review - 1st', 'Management Review - 2nd', 'Management Approved'];
    const cleanedAssignedUser = row.assignedUser?.replace(/\s+/g, '') || '';
    const cleanedUserName = this.userAccount?.name?.replace(/\s+/g, '') || '';

    return validStatuses.includes(row.status)
      && cleanedAssignedUser !== cleanedUserName
      && this.userService.roleCheck(['Admin']);
  }

  public onTabChanged($event: MatTabChangeEvent): void {
    if ($event.index === 0) {
      this.myProjects = false;
    } else if ($event.index === 1) {
      this.myProjects = true;
    }

    this.selectedTab = $event.index;
    sessionStorage.setItem('tabIndex', $event.index.toString());
    sessionStorage.setItem('tabLabel', $event.tab.textLabel);
    this.myProjectsFlagApi = this.myProjects;

    this.clearFiltersAndSort();
    this.onPaginationNavigate();
  }

  public fetchDashboardData(): void {
    const projectsCount$ = this.dashboardService?.fetchSampleCount();
    const materialTypes$ = this.dashboardService?.fetchMaterialTypes();
    const projectStatuses$ = this.dashboardService.fetchProjectStatuses();
    forkJoin({
      projectsCount: projectsCount$,
      materialTypes: materialTypes$,
      projectStatuses: projectStatuses$,
    }).subscribe({
      next: ({ projectsCount, materialTypes, projectStatuses }) => {
        this.projectsCount = projectsCount;
        this.materialTypes = Array.isArray(materialTypes) ? materialTypes : [];
        this.materialTypes = this.materialTypes
          ?.sort((a, b) => a.order - b.order)
          ?.filter((materialType) => !materialType?.disabled);
        this.dashboardService.projectStatuses = projectStatuses;
        this.projectStatuses = projectStatuses.sort((a, b) => a.order - b.order);
        // this.materialTypes = [typesData, ...this.materialTypes];
        if (Array.isArray(this.materialTypes)) {
          this.materialTypes = [typesData, ...this.materialTypes];
        } else {
          // Handle the case where materialTypes is not an array
          this.materialTypes = [typesData];
        }
        this.projectStatuses = [typesData, ...this.projectStatuses];
      },
    });
  }

  onMobileSoilTypeCheckboxChange(type: string, checked: boolean) {
    const key = (type || '').toString().toLowerCase();

    // Direct API label mapping for mobile
    const labelMap: { [key: string]: string } = {
      'precast': 'Pre Cast',
      'native': 'Native Soil'
    };
    const targetLabel = labelMap[key] || type;

    // Update mobile-specific selection tracker only
    const mobileIdx = this.selectedMobileMaterialTypes.indexOf(key);
    if (checked && mobileIdx === -1) {
      this.selectedMobileMaterialTypes.push(key);
    } else if (!checked && mobileIdx > -1) {
      this.selectedMobileMaterialTypes.splice(mobileIdx, 1);
    }

    // Build mobile-specific filter string (independent from desktop)
    const mobileMaterialFilter = this.selectedMobileMaterialTypes.length > 0 
      ? this.selectedMobileMaterialTypes.map(k => labelMap[k] || k).join(',')
      : '';
    
    // Use mobile-only sessionStorage key
    if (mobileMaterialFilter.length > 0) {
      sessionStorage.setItem('mobileMaterialType', mobileMaterialFilter);
    } else {
      sessionStorage.removeItem('mobileMaterialType');
    }
    
    // Reset to first page for mobile results only
    let mobileCurrentPage = 1;
    sessionStorage.setItem('mobileCurrentPage', '1');
    
    // Fetch projects using mobile-specific filter
    this.fetchMobileProjects(mobileMaterialFilter, mobileCurrentPage);
  }

  private fetchMobileProjects(mobileMaterialFilter: string, mobileCurrentPage: number): void {
    // If no filters selected on mobile, show empty
    if (mobileMaterialFilter === '') {
      this.projectRecords = [];
      this.dataSource = new MatTableDataSource<IDashboardItems>([]);
      this.totalRecords = 0;
      this.totalPages = 0;
      this.selection.clear();
      return;
    }

    const sessionSearchKeyWord = sessionStorage.getItem('searchKeyWord');
    const sessionSearchColumn = sessionStorage.getItem('searchColumn');
    let decodedSearch = '';
    if (sessionSearchKeyWord !== null && sessionSearchKeyWord !== undefined) {
      decodedSearch = decodeURIComponent(sessionSearchKeyWord);
    }

    const mobileRecordsPerPage = 100;
    const mobileColumnName = '';

    this.projectsSubscription = this.dashboardService
      ?.fetchProjects(
        mobileCurrentPage,
        decodedSearch,
        sessionSearchColumn ?? 'all',
        mobileRecordsPerPage,
        mobileColumnName,
        this.myProjectsFlagApi,
        false,
        false,
        mobileMaterialFilter, // Use mobile-only filter
        '', // No project status filter on mobile
      )
      .subscribe({
        next: (response: IDashboardItems[]) => {
          this.projectRecords = response;
          this.dataSource = new MatTableDataSource<IDashboardItems>(this.projectRecords);
          this.selection.clear();
        },
      });
  }

  onScroll(event: any) {
    const element = event.target;
    const scrollTop = element.scrollTop;
    const scrollHeight = element.scrollHeight;
    const clientHeight = element.clientHeight;
    if (scrollTop + clientHeight >= scrollHeight - 50 && !this.isLoading) {
      this.isLoading = true;
      this.mobilePage++;
      this.fetchProjects();

      const sub = this.projectsSubscription;
      if (sub) {
        const resetLoading = () => { this.isLoading = false; sub.unsubscribe(); };
        sub.add(resetLoading);
      } else {
        setTimeout(() => { this.isLoading = false; }, 500);
      }
    }
  }

  private fetchProjects(): void {
    // Wait for the office locations so the first request already carries the office filter
    if (!this.isMobile && !this.officeLocationsLoaded) {
      this.pendingProjectsFetch = true;
      return;
    }
    this.pendingProjectsFetch = false;

    const sessionMaterialType = sessionStorage.getItem('materialType');
    const sessionProjectStatus = sessionStorage.getItem('projectStatus');
    let projectStatus = sessionProjectStatus || this.projectStatus;

    if (sessionStorage.getItem('tabLabel') === 'REPORTS TO REVIEW') {
      projectStatus = 'Management Review - 1st,Management Review - 2nd,Management Approved';
    }

    const colNameSort = sessionStorage.getItem('columnName');
    if (colNameSort) {
      this.columnName = colNameSort;
    }

    let sessionSearchKeyWord = sessionStorage.getItem('searchKeyWord');
    let sessionSearchColumn = sessionStorage.getItem('searchColumn');
    if (sessionSearchKeyWord) {
      sessionSearchKeyWord = decodeURIComponent(sessionSearchKeyWord);
    }

    this.fetchProjectCountbasedParameters();
    const page = this.isMobile ? this.mobilePage : JSON.parse(sessionStorage.getItem('currentPage') as any) || this.currentPage;
    const pageSize = this.isMobile ? this.mobilePageSize : JSON.parse(sessionStorage.getItem('recordsPerPage') as any) || this.recordsPerPage;

    this.projectsSubscription = this.dashboardService
    ?.fetchProjects(
      page,
      sessionSearchKeyWord || this.searchKeyWord,
      sessionSearchColumn || this.searchColumn,
      pageSize,
      this.columnName,
      this.myProjectsFlagApi,
      JSON.parse(sessionStorage.getItem('isActiveProjectFlagApi') as any) || this.isActiveProjectFlagApi,
      JSON.parse(sessionStorage.getItem('isMixId') as any) || this.isMixId,
      sessionMaterialType || this.materialType,
      projectStatus,
      this.officeLocationFilterParam,
    )
    .subscribe({
      next: (response: IDashboardItems[]) => {
        if (this.isMobile && this.mobilePage > 1) {
          this.projectRecords = [...this.projectRecords, ...response];
        } else {
          this.projectRecords = response;
        }
        this.dataSource = new MatTableDataSource<IDashboardItems>(this.projectRecords);
        this.selection.clear();
      },
    });
  }

  private fetchProjectCountbasedParameters(): void {
    const sessionMaterialType = sessionStorage.getItem('materialType');
    const sessionProjectStatus = sessionStorage.getItem('projectStatus');
    let sessionSearchKeyword = sessionStorage.getItem('searchKeyWord');
    let sessionSearchColumn = sessionStorage.getItem('searchColumn');
    if (sessionSearchKeyword !== null && sessionSearchKeyword !== undefined) {
      sessionSearchKeyword = decodeURIComponent(sessionSearchKeyword);
    }
    this.projectsSubscription = this.dashboardService
      ?.fetchProjectsCount(
        JSON.parse(sessionStorage.getItem('currentPage') as any)
          ? JSON.parse(sessionStorage.getItem('currentPage') as any)
          : this.currentPage,
        sessionSearchKeyword || this.searchKeyWord,
        sessionSearchColumn || this.searchColumn,
        this.myProjectsFlagApi,
        JSON.parse(sessionStorage.getItem('isActiveProjectFlagApi') as any)
          ? JSON.parse(sessionStorage.getItem('isActiveProjectFlagApi') as any)
          : this.isActiveProjectFlagApi,
        JSON.parse(sessionStorage.getItem('isMixId') as any)
          ? JSON.parse(sessionStorage.getItem('isMixId') as any)
          : this.isMixId,
        this.columnName,
        sessionMaterialType || this.materialType,
        sessionProjectStatus || this.projectStatus,
        this.officeLocationFilterParam,
      )
      ?.subscribe({
        next: (response: number) => {
          this.totalRecords = response;
          this.showSearchResultCount = !!this.searchKeyWord;
          this.totalPages = Math.ceil(response / this.recordsPerPage);
          if (this.totalPages === 0) {
            this.projectRecords = [];
          }
        },
      });
  }

  private fetchProjectsCount(): void {
    this.projectsSubscription = this.dashboardService?.fetchSampleCount()?.subscribe({
      next: (response: ProjectsCount) => {
        this.projectsCount = response;
      },
    });
  }

  private removeItem(
    item: string,
    itemIndex: number,
    selectedItemArray: string[],
    targetItem: string,
    targetItems: string[],
  ): void {
    if (itemIndex > -1) {
      selectedItemArray.splice(itemIndex, 1);
      this.removeTargetItemIfAllSelected(targetItem, targetItems);
    }
  }

  private addItem(
    item: string,
    selectedItemArray: string[],
    targetItem: string,
    targetItems: { label: string }[],
  ): void {
    selectedItemArray.push(item);
    this.addTargetItemAllIfAllSelected(item, selectedItemArray, targetItem, targetItems);
  }

  private removeTargetItemIfAllSelected(targetItem: string, targetItems: string[]): void {
    const allIndex = targetItems.indexOf(targetItem);
    if (allIndex > -1) {
      targetItems.splice(allIndex, 1);
    }
  }

  private addTargetItemAllIfAllSelected(
    item: string,
    selectedItemArray: string[],
    targetItem: string,
    targetItems: { label: string }[],
  ): void {
    const isAllSelected = !selectedItemArray.includes(targetItem) && selectedItemArray.length === targetItems.length - 1;
    if (isAllSelected) {
      selectedItemArray.push(targetItem);
    }
  }

  private updateProperty(selectedItemArray: string[], targetProperty: string, allItems: { label: string }[]): void {
    const property = selectedItemArray.length > 0
      ? selectedItemArray.filter((selectedItem) => selectedItem).toString()
      : allItems.map((item) => item.label).toString();
    if (targetProperty === 'materialType') {
      this.materialType = property;
    } else {
      this.projectStatus = property;
    }
  }

  private createProjectReport(data: Blob, element: any): void {
    const downloadURL = window?.URL?.createObjectURL(data);
    const link = document.createElement('a');
    const date = new Date();
    const fileName = `${element?.customer}-${element?.projectName}-${element?.soilType === 'Pre Cast' ? 'PC' : 'NS'}-${element?.projectNumber
      }-${date.getMonth() + 1}${date.getDate().toString().padStart(2, '0')}${date.getFullYear().toString().slice(2)}`;
    link.href = downloadURL;
    link.download = fileName;
    link.click();
  }

  private clearFiltersAndSort(projectStatus = ''): void {
    // this.selectedMaterialTypes = [];
    // this.selectedProjectStatus = [];
    const valueMaterialType = sessionStorage.getItem('materialType');
    const valueProjectStatus = sessionStorage.getItem('projectStatus');
    if (valueMaterialType === null || valueMaterialType === '') {
      this.selectedMaterialTypes = [];
      this.materialType = '';
    }
    if (valueProjectStatus === null || valueProjectStatus === '') {
      this.selectedProjectStatus = [];
      this.projectStatus = '';
    }
    this.projectStatus = projectStatus;
    if (sessionStorage.getItem('currentPage')) {
      this.currentPage = JSON.parse(sessionStorage.getItem('currentPage') as any);
    } else {
      this.currentPage = 1;
    }

    this.columnName = '';
    //  this.searchKeyWord = ''; //commented this to retain the value on the tab section change
    this.showSearchResultCount = false;
  }

  review(projectID: string, soilType: string): void {
    const params = {
      f: 'd',
    };
    const navigationExtras: NavigationExtras = {
      queryParams: params,
    };
    const navigateSoilType = soilType === 'Pre Cast' ? 'precast' : 'nativesoil';
    this.formService.updateData(null);
    this.formService.fetchFormData(projectID, navigateSoilType).subscribe({
      next: (data) => {
        if (data && data.samples && Array.isArray(data.samples)) {
          this.filteredNativeSamples = [];
          this.filteredPrecastSamples = [];

          data.samples.forEach((sample: any) => {
            if (soilType === 'Pre Cast') {
              const precastSample = sample as IPrecastSample;
              this.filteredPrecastSamples.push(precastSample);
            } else {
              const nativeSample = sample as INativeSample;
              this.filteredNativeSamples.push(nativeSample);
            }
          });

          navigationExtras.state = { isShipmentReceived: true };
          // Check if all sampleStatusTypeId values are null for Pre Cast samples
          if (soilType === 'Pre Cast') {
            const allPrecastNull = this.filteredPrecastSamples.every((sample) => sample.sampleStatusTypeId === null);
            if (allPrecastNull) {
              navigationExtras.state = { isShipmentReceived: false };
            }
          } else {
            // Check for Native samples
            const allNativeNull = this.filteredNativeSamples.every((sample) => sample.sampleStatusTypeId === null);
            if (allNativeNull) {
              navigationExtras.state = { isShipmentReceived: false };
            }
          }

          this.router.navigate([`/review/form/${navigateSoilType}/${projectID}`], navigationExtras);
        } else {
        }
      },
      error: () => { },
    });
  }

  ngOnDestroy() {
    this.destroying$.next(undefined);
    this.destroying$.complete();
    this.projectsSubscription.unsubscribe();
    this.reportDownloadSubscription.unsubscribe();
    this.userSubscription.unsubscribe();
    this.countDown.unsubscribe();
    this.trackEventService.wake$.unsubscribe();
  }

  getBackgroundImage(soilType: string): string {
    const overlay = "linear-gradient(rgba(255,255,255,0.80), rgba(255,255,255,0.80))";

    if (soilType === 'Pre Cast') {
      return `${overlay}, url('/assets/images/precast.png')`;
    } else {
      return `${overlay}, url('/assets/images/native-soil.png')`;
    }
  }

  splitStringByComma(input: string): string[] {
    return input.split(',').map((value) => value.trim());
  }

  clearFilters() {
    this.isMixId = false; // Clear include Mix Id CheckBox
    this.isActiveProjectFlagApi = false; // Clear include inactive record CheckBox
    // Make both the checkbox default
    this.inActiveRecordsCheckboxValue = false;
    this.mixIdCheckboxValue = false;

    this.columnName = '';
    this.selectedMaterialTypes = [];
    this.selectedProjectStatus = [];
    this.materialType = '';
    this.projectStatus = '';

    sessionStorage.removeItem('mixIdCheckboxValue'); // Remove mix Id value from session
    sessionStorage.removeItem('isActiveProjectFlagApi'); // Remove include inactive value from session
    sessionStorage.removeItem('materialType');
    sessionStorage.removeItem('projectStatus');
    sessionStorage.clear();
    // A user with a single location stays fixed to it; everyone else goes back to All Locations
    this.selectedOfficeLocations = this.officeLocations.length === 1 ? [this.officeLocations[0].id] : [];
    if (this.selectedOfficeLocations.length > 0) {
      sessionStorage.setItem('officeLocationId', this.selectedOfficeLocations.join(','));
    }
    this.getDashboardData();
  }

  isAnyFilterApplied(): boolean {
    const materialType = sessionStorage.getItem('materialType');
    const projectStatus = sessionStorage.getItem('projectStatus');
    return (
      (materialType && materialType !== '')
      || (projectStatus && projectStatus !== '')
      || this.mixIdCheckboxValue
      || this.inActiveRecordsCheckboxValue
      || this.isOfficeLocationFilterApplied()
    );
  }

  removeSearchKeyWord() {
    sessionStorage.removeItem('searchKeyWord');
  }

  onKeyPress(event: KeyboardEvent): void {
    if (this.searchKeyWord) {
      sessionStorage.removeItem('searchKeyWord');
      this.isCheckboxDisabled = false;
      this.isMixIdCheckboxDisabled = false;
    }
  }

  onKeyDown(event: KeyboardEvent): void {
    if (event.key === 'Tab') {
      event.preventDefault();
      this.askGeo();
    }
  }

  deleteProject(projectID: string, soilType: string, multipleSelected: boolean): void {
    const dialogData = {
      title: multipleSelected ? 'Delete records' : 'Delete record',
      content: 'Are you sure you want to delete it? <br>Please download a copy of the Project related data in a zipped folder to avoid any loss.',
      cancelText: 'No, do not delete',
      continueText: 'Yes, delete it permanently',
    };

    this.deleteRecordDialogRef = this.dialog?.open(ConfirmationDialogComponent, {
      panelClass: 'confirmation-dialog',
      data: dialogData,
      disableClose: true,
    });

    this.deleteRecordDialogRef?.afterClosed()?.subscribe((response?: string) => {
      if (response !== 'YES') return;

      const projectsToDelete: DeleteProjectRequest[] = multipleSelected
        ? this.selection.selected.map(project => ({
          ProjectId: project.id,
          SoilType: project.soilType === 'Native Soil' ? 1 : 0
        }))
        : [{
          ProjectId: projectID,
          SoilType: soilType === 'Native Soil' ? 1 : 0
        }];

      this.dashboardService.softDeleteRecords(projectsToDelete).subscribe({
        next: (response: any) => {
          if (!response) return;

          this.getDashboardData();

          const message = multipleSelected
            ? messagesConfig.softDeleteMessageMultiple.message
            : messagesConfig.softDeleteMessage.message;

          this.snackBar.open(message, 'DONE', {
            duration: 3000,
            verticalPosition: 'top',
            panelClass: ['default-snackbar'],
          });
        },
      });
    });
  }

  restoreRecord(projectID: string): void {
    this.deleteRecordDialogRef = this.dialog?.open(ConfirmationDialogComponent, {
      panelClass: 'confirmation-dialog',
      data: {
        title: 'Restore deleted record',
        content: 'Do you want to make the Project record Active?',
        cancelText: 'No, Do not restore it',
        continueText: 'Yes, Restore record',
      },
      disableClose: true,
    });
    this.deleteRecordDialogRef?.afterClosed()?.subscribe((response?: string) => {
      if (response === 'YES') {
        this.dashboardService
          .restoreDeleteRecord(projectID)
          .subscribe({
            next: (response) => {
              if (!response) return;
              this.getDashboardData();
              this.snackBar.open(messagesConfig.restoreDeleteMessage.message, 'DONE', {
                duration: 3000,
                verticalPosition: 'top',
                panelClass: ['default-snackbar'],
              });
            },
          });
      }
    });
  }

  isSearchInMixId($event: MatCheckboxChange): void {
    if ($event.checked) {
      this.isMixId = true;
      sessionStorage.setItem('mixIdCheckboxValue', this.mixIdCheckboxValue.toString());
      this.clearFiltersAndSort();
      this.onPaginationNavigate();
    } else {
      this.isMixId = false;
      sessionStorage.setItem('mixIdCheckboxValue', this.mixIdCheckboxValue.toString());
      this.clearFiltersAndSort();
      this.onPaginationNavigate();
    }
  }

  includeInactiveRecords($event: MatCheckboxChange): void {
    if ($event.checked) {
      this.handleCheck();
    } else {
      this.handleUncheck();
    }
  }

  handleCheck() {
    if (this.userService.roleCheck(['Admin', 'Manager', 'Reportwriter', 'Accounting'])) {
      this.isActiveProjectFlagApi = true;
      this.inActiveRecordsCheckboxValue = true;
      sessionStorage.setItem('isActiveProjectFlagApi', this.isActiveProjectFlagApi.toString());
      this.clearFiltersAndSort();
      this.onPaginationNavigate();
    }
  }

  handleUncheck() {
    if (this.userService.roleCheck(['Admin', 'Manager', 'Reportwriter', 'Accounting'])) {
      this.isActiveProjectFlagApi = false;
      this.inActiveRecordsCheckboxValue = false;
      sessionStorage.setItem('isActiveProjectFlagApi', this.isActiveProjectFlagApi.toString());
      this.clearFiltersAndSort();
      this.onPaginationNavigate();
    }
  }

  inactivateProjects(projectID: string, multipleSelected: boolean): void {
    const isMultiple = multipleSelected;

    const dialogData = {
      title: isMultiple ? 'Deactivate all the selected records' : 'Deactivate the record',
      content: isMultiple
        ? 'This will make the selected project records inactive. Are you sure you want to deactivate them? Kindly confirm.'
        : 'This will make the project record inactive. Are you sure you want to deactivate it? Kindly confirm.',
      cancelText: isMultiple ? 'No, do not deactivate' : 'No, do not deactivate it',
      continueText: 'Yes, deactivate',
    };

    this.deleteRecordDialogRef = this.dialog?.open(ConfirmationDialogComponent, {
      panelClass: 'confirmation-dialog',
      data: dialogData,
      disableClose: true,
    });

    this.deleteRecordDialogRef?.afterClosed()?.subscribe((response?: string) => {
      if (response !== 'YES') return;

      const projectsToDeactivate: DeactivateProjectRequest[] = isMultiple
        ? this.selection.selected.map(project => ({
          ProjectId: project.id,
        }))
        : [{
          ProjectId: projectID,
        }];

      this.dashboardService
        .inactivateProjects(projectsToDeactivate)
        .subscribe({
          next: (response: any) => {
            if (!response) return;
            this.getDashboardData();

            const message = isMultiple
              ? messagesConfig.inActivateMultipleRecordsMessage.message
              : messagesConfig.inActivateRecordMessage.message;

            this.snackBar.open(message, 'DONE', {
              duration: 3000,
              verticalPosition: 'top',
              panelClass: ['default-snackbar'],
            });
          },
        });
    });
  }

  /** Merge Project */
  mergeProject(projectID: string, soilType: string): void {
    const navigateSoilType = soilType === 'Pre Cast' ? 'precast' : 'nativesoil';
    this.formService.updateData(null);
    this.router.navigate([`/merge/form/${navigateSoilType}/${projectID}`]);
  }

  addRates(projectID: string, soilType: string, status: string): void {
    const navigateSoilType = soilType === 'Pre Cast' ? 'precast' : 'nativesoil';
    this.formService.updateData(null);
    this.rowStatus = status;
    this.router.navigate([`/accounting/form/${navigateSoilType}/${projectID}`], {
      queryParams: {
        status: this.rowStatus,
      },
    });
  }

  manageBilling(projectID: string, soilType: string): void {
    const navigateSoilType = soilType === 'Pre Cast' ? 'precast' : 'nativesoil';
    this.formService.updateData(null);
    this.router.navigate([`/accounting/form/${navigateSoilType}/${projectID}`]);
  }

  shouldShowMergeButton(row: any): boolean {
    // Only show merge button if isSplit is true, allowedStatuses include the status, and isMerge is false
    return row.isMerge !== true && row.isSplit === true && this.allowedStatuses.includes(row.status);
  }

  shouldShowAdminManageReport(row: any): boolean {
    // Only show admin Manage Report button
    return this.allowAdminStatus.includes(row.status);
  }

  shouldShowManageReport(row: any): boolean {
    // Only show Manage Report button
    return this.manageReportAllowList.includes(row.status);
  }

  shouldShowAccountManageReport(row: any): boolean {
    return this.accountRoleAllowList.includes(row.status);
  }

  shouldShowAddRate(row: any): boolean {
    // Only show Add Rate button
    return this.addRateAllowList.includes(row.status);
  }

  shouldShowBilling(row: any): boolean {
    // Only show Manage billing button
    return this.billingAllowList.includes(row.status);
  }

  combine() {
    this.router.navigateByUrl('combine');
  }

  projectAudit360(projectID: string, soilType: string, projectNumber: string, projectName: string, customer: string, status: string) {
    const navigateSoilType = soilType === 'Pre Cast' ? 'precast' : 'nativesoil';
    this.router.navigateByUrl(`project-history-360?soilType=${navigateSoilType}&&projectId=${projectID}&&projectNumber=${projectNumber}&&projectName=${projectName}&&customer=${customer}&&status=${status}`);

    // this.router.navigateByUrl('project-history-360');
  }

  isMenuVisible(row: any): boolean {
    // Check if there are any actions available to show in the menu
    return (this.userService.roleCheck(['Accounting']) && this.shouldShowAccountManageReport(row))
      || (this.userService.roleCheck(['Manager', 'Admin', 'Reportwriter', 'Labtech']));
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows && numRows > 0;
  }

  isIndeterminate() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected > 0 && numSelected < numRows;
  }

  masterToggle() {
    if (this.isAllSelected()) {
      this.selection.clear();
    } else {
      this.selection.select(...this.dataSource.data);
    }
  }

  toggleSelection(row: IDashboardItems) {
    this.selection.toggle(row);
  }

  isMultipleSelected(row: any): boolean {
    return this.selection.selected.length > 1 && this.selection.selected.includes(row);
  }
}
